import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useTeam() {
  const { user, getAccessTokenSilently } = useAuth0()

  const { data: teams, isLoading } = useQuery({
    queryKey: ['teams', user?.sub],
    queryFn: async () => {
      console.log('Requesting token with audience:', import.meta.env.VITE_AUTH0_AUDIENCE)
      console.log('Requesting token with scope:', 'openid profile email')
      
      const token = await getAccessTokenSilently({
        authorizationParams: {
          // Temporarily remove audience requirement to test
          // audience: import.meta.env.VITE_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      })
      
      console.log('Received token:', token.substring(0, 20) + '...')
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.get('/teams')
      return response.data
    },
    enabled: !!user,
  })

  // For now, return the first team (Company Controlling)
  const currentTeam = teams?.[0]

  return {
    currentTeam,
    teams,
    isLoading,
  }
}
